import { useNavigate } from "react-router-dom";
import { useComparison } from "@/contexts/ComparisonContext";
import { Button } from "@/components/ui/button";
import { X, GitCompare, Trash2 } from "lucide-react";

const ComparisonBar = () => {
  const { comparisonList, removeFromComparison, clearComparison, maxItems } = useComparison();
  const navigate = useNavigate();

  if (comparisonList.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border shadow-lg">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <GitCompare className="h-5 w-5 text-primary" />
            <span className="font-medium">
              Compare ({comparisonList.length}/{maxItems})
            </span>
          </div>

          <div className="flex items-center gap-2 flex-1 overflow-x-auto">
            {comparisonList.map((artwork) => (
              <div
                key={artwork.id}
                className="relative flex-shrink-0 group"
              >
                <img
                  src={artwork.image_url}
                  alt={artwork.title}
                  className="w-12 h-12 rounded-md object-cover border-2 border-primary/50"
                />
                <button
                  onClick={() => removeFromComparison(artwork.id)}
                  className="absolute -top-1 -right-1 bg-destructive text-destructive-foreground rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <X className="h-3 w-3" />
                </button>
              </div>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={clearComparison}
            >
              <Trash2 className="h-4 w-4 mr-1" />
              Clear
            </Button>
            <Button
              size="sm"
              onClick={() => navigate("/compare")}
              disabled={comparisonList.length < 2}
            >
              <GitCompare className="h-4 w-4 mr-1" />
              Compare
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonBar;
